import { render, staticRenderFns } from "./receive.vue?vue&type=template&id=40357814&scoped=true"
import script from "./receive.vue?vue&type=script&lang=js"
export * from "./receive.vue?vue&type=script&lang=js"
import style0 from "./receive.vue?vue&type=style&index=0&id=40357814&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40357814",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40357814')) {
      api.createRecord('40357814', component.options)
    } else {
      api.reload('40357814', component.options)
    }
    module.hot.accept("./receive.vue?vue&type=template&id=40357814&scoped=true", function () {
      api.rerender('40357814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/fixed/components/receive.vue"
export default component.exports